import { useMemo } from 'react';
import { usePrefs, useLabels, useFlags } from 'wsm-common-data';

export const useBuildTabs = (vehicles) => {
	const { showAllModelsTab, displayStyle, tabOrder } = usePrefs();
	const labels = useLabels();
	const allLabel = labels.get('ALL');
	const flags = useFlags();
	const enableModelSelectorService = flags['enable-model-selector-service'];
	const tabNames = useMemo(() => {
		const rawTabNames = Object.keys(vehicles).filter(
			(tab) => tab !== allLabel
		);
		let newTabNames = rawTabNames;

		if (tabOrder && !enableModelSelectorService) {
			const tabs = tabOrder.split(',');
			const orderedTabs = new Set();
			tabs.forEach((tabName) => {
				// Validate that the tab name is in the raw tab names
				// we should only add valid tabs to the orderedTabs set
				const tabToAdd = rawTabNames.find(
					(rawTabName) =>
						rawTabName.localeCompare(tabName.trim(), undefined, {
							sensitivity: 'base'
						}) === 0
				);
				if (tabToAdd) {
					orderedTabs.add(tabToAdd);
				}
			});
			// Adding the tabs that are not included in the tabOrder
			// at the end of the set
			rawTabNames.forEach((item) => {
				if (!orderedTabs.has(item)) {
					orderedTabs.add(item);
				}
			});
			newTabNames = Array.from(orderedTabs);
		}

		if (showAllModelsTab === 'true' && vehicles) {
			if (displayStyle === 'largeVehicle') {
				// Add the All tab to the end of the array
				newTabNames.push(allLabel);
			} else {
				// Add the All tab to the beginning of the array
				newTabNames.unshift(allLabel);
			}
		}

		return newTabNames;
	}, [vehicles, showAllModelsTab, displayStyle, allLabel]);
	return tabNames;
};
